var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiamondRound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 68.764 60.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-3 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3 {\r\n        stroke: #000;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-1 {\r\n        fill-rule: evenodd;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: none;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.345,29.948A27.363,27.363,0,1,1,33.982,2.585,27.363,27.363,0,0,1,61.345,29.948"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.345,29.948A27.363,27.363,0,1,1,33.982,2.585,27.363,27.363,0,0,1,61.345,29.948Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 14.633,
    y1: 10.599,
    x2: 53.33,
    y2: 49.296
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 14.633,
    y1: 49.296,
    x2: 53.33,
    y2: 10.599
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 6.619,
    y1: 29.948,
    x2: 61.345,
    y2: 29.948
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 33.982,
    y1: 57.311,
    x2: 33.982,
    y2: 2.585
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 19.208,
    y: 15.173,
    width: 29.643,
    height: 29.644
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.208,
    y: 15.173,
    width: 29.643,
    height: 29.644
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.519,
    y: 15.485,
    width: 29.022,
    height: 29.022,
    transform: "translate(-11.243 32.848) rotate(-45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondRound);
export default __webpack_public_path__ + "static/media/Diamond_Round.cd610bed452fbb21907f73aec8e9fbc2.svg";
export { ForwardRef as ReactComponent };